import Scenes from "oc-threejs/Scenes";
import "three/examples/js/postprocessing/EffectComposer.js";

/**
 * Erlaubt es, innerhalb der EffectComposer-Kette Objekte vorübergehend auszublenden
 */
export default class VisibleSwitchRenderPass extends THREE.Pass {

    list = null;

    constructor(predicate) {
        super();
        this.predicate = predicate;
        this.renderToScreen = true;
        this.clear = false;
        this.needsSwap = false;
        this.inverse = false;
    }

    render( renderer, writeBuffer, readBuffer, delta, maskActive ) {
        if (this.list===null) {
            this.list = Scenes.filter(STAGE.scene,x=>x.visible && this.predicate(x));
            this.list.forEach(x=>x.visible=false);
        } else {
            this.list.forEach(x=>x.visible=true);
            this.list = null;
        }
    }

}